export const formatNumberByLocale = (locale: string, value: number | string) => {
  const digitMaps: Record<string, string[]> = {
    en: ["0","1","2","3","4","5","6","7","8","9"],
    hi: ["०","१","२","३","४","५","६","७","८","९"],
    mr: ["०","१","२","३","४","५","६","७","८","९"],
    gu: ["૦","૧","૨","૩","૪","૫","૬","૭","૮","૯"],
    kn: ["೦","೧","೨","೩","೪","೫","೬","೭","೮","೯"],
    bn: ["০","১","২","৩","৪","৫","৬","৭","৮","৯"],
    ta: ["௦","௧","௨","௩","௪","௫","௬","௭","௮","௯"],
    te: ["౦","౧","౨","౩","౪","౫","౬","౭","౮","౯"],
    pa: ["੦","੧","੨","੩","੪","੫","੬","੭","੮","੯"],
    ml: ["൦","൧","൨","൩","൪","൫","൬","൭","൮","൯"]






  };

  const activeDigits = digitMaps[locale] || digitMaps["en"];

  return String(value)
    .split("")
    .map((ch) => {
      if (!/^[0-9]$/.test(ch)) return ch;
      return activeDigits[Number(ch)];
    })
    .join("");
};
